// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"54cdfe52","136":"e0792639","224":"54cdfe52","238":"ca9ccbd1","450":"07952bbe","484":"dea4d5d0","503":"54cdfe52","518":"54cdfe52","753":"54cdfe52"}[chunkId] + ".chunk.css";
};